// src/components/DocumentButton.jsx

import React from "react";
import { Button, Typography } from "@mui/material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

function DocumentButton({ doc, onClick }) {
  return (
    <Button
      variant="outlined"
      color="primary"
      onClick={onClick}
      sx={{
        width: "100%",
        height: 200, // Increased height for better visibility
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 2,
        textTransform: "none",
        borderRadius: 2,

        borderColor: "#d00000",
        color: "#d00000",
        "&:hover": {
          borderColor: "#a10000",
          backgroundColor: "rgba(208,0,0,0.08)",
        },
      }}
    >
      <InsertDriveFileIcon sx={{ fontSize: 50, marginBottom: 2 }} />
      <Typography
        variant="body2"
        align="center"
        sx={{
          wordBreak: "break-word",
        }}
      >
        {doc.title}
      </Typography>
    </Button>
  );
}

export default DocumentButton;
